$(document).ready(function(){
  var getcollectionhandle = $("#promo-banner-image").html();
  $("#gspfProduct").append(getcollectionhandle);
  if($(window).width() > 768){ 
    var sliderHeight = $("#shopify-section-1583301538166").height();
    var actualsliderHeight = sliderHeight - 60;
    $("#shopify-section-1588747037349").css("marginTop",actualsliderHeight);
  }
  $(".label_custom_variant").on("click", function(){
    $(this).css({"background":"#a8c5ce","color":"#fff", "border-color": "#a8c5ce"});
    $(this).siblings(".label_custom_variant").css({"background":"#fff","color":"#a8c5ce","border-color": "#000"});
  });
  $(".label_custom_variant").on("click", function(){
    let dfdfdfddf = $(this).prev("input").val()
    $(".single-option-selector").empty();
    $(".single-option-selector").html('<option value="'+dfdfdfddf+'">'+dfdfdfddf+'</option>');
    $(".select-wrapper .selected-text").html(dfdfdfddf);
  });
  // Copy the legacy description only when both expected containers exist.
  if ($('#get_collecton_cont_footer').length && $('#get_collecton_cont').length) {
    let collection_contentjava = $('#get_collecton_cont_footer').html();
    $('#get_collecton_cont').html(collection_contentjava);
    $('#get_collecton_cont p:first').css('display', 'block');
    $('#get_collecton_cont_footer p:first').css('display', 'none');
  }
  let collectiondescH = $('#get_collecton_cont_footer').height();
  if(collectiondescH > 220){
    $(".meta_desc_readmore").css({"display": "block"});
    $("#get_collecton_cont_footer").css({"height": "220px","overflow":"hidden"});
    $(".meta_desc_readmore").on("click",function(){
      $(".meta_desc_readmore").css({"display": "none"});
      $(".meta_desc_readmore1").css({"display": "block"});
      $("#get_collecton_cont_footer").css({"height": "auto","overflow":"visible"});
    });
    $(".meta_desc_readmore1").on("click",function(){
      $(".meta_desc_readmore").css({"display": "block"});
      $(".meta_desc_readmore1").css({"display": "none"});
      $("#get_collecton_cont_footer").css({"height": "220px","overflow":"hidden"});
    });
  };
  $("#shopify-section-footer .upper-footer .upper-footer-item:last").addClass("footer_bottom_content_richtext");  
  let footer_bottomHeight_text = $(".footer_bottom_content_richtext").height();  
  if(footer_bottomHeight_text > 230){
    $("#readmore_footer").css({"display": "block"});
    $(".footer_bottom_content_richtext").css({"height": "230px","overflow":"hidden"});
    $("#readmore_footer").on("click",function(){
      $("#readmore_footer").css({"display": "none"});
      $("#readmore_footer1").css({"display": "block"});
      $(".footer_bottom_content_richtext").css({"height": "auto","overflow":"visible"});
    });
    $("#readmore_footer1").on("click",function(){
      $("#readmore_footer1").css({"display": "none"});
      $("#readmore_footer").css({"display": "block"});
      $(".footer_bottom_content_richtext").css({"height": "230px","overflow":"hidden"});
    });
  };
  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        nav:true
      },
      600:{
        items:3,
        nav:false
      },
      1000:{
        items:4,
        nav:true,
        loop:false
      }
    }
  })  
  $('.owl-carousel-3').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        nav:true
      },
      600:{
        items:2,
        nav:false
      },
      767:{
        items:3,
        nav:false
      },
      1000:{
        items:3,
        nav:true,
        loop: false
      }
    }
  });
  $('.owl-carousel-homeBanner').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        nav:true
      },
      600:{
        items:2,
        nav:false
      },
      767:{
        items:3,
        nav:false
      },
      1000:{
        items:3,
        nav:true,
        loop: false
      }
    }
  });  
  $('.owl-carousel-4').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        nav:true
      },
      600:{
        items:2,
        nav:false
      },
      1000:{
        items:3,
        nav:true,
        loop: false
      }
    }
  });

  //==================  Location JS  ==================//
  function countryFromIp()
  {
    $.ajax({
      url: "https://ipinfo.io/json",
      dataType: "json",
      async: false,
      success: function(data){
        window.dataCountry = data.country;
      }
    });
    return window.dataCountry;
  }
  window.country = countryFromIp();
  console.log(window.country);
  if(window.country == 'US')
  {
    $('#currencies').val('USD');
    $('#currencies').change();
  }
  if(window.country == 'AE')
  {
    $('#currencies').val('AED');
    $('#currencies').change();
  }
  //===================================================//
});

$("#shopify-section-1588832064903").ready(function(){
  $("#shopify-section-1588832064903 section .home-collections-content").prepend("<h5>Other <br><span id=\"f\"> Featured <\span> <br> <span id=\"pro\"> Products <\span></h5>");
});
$(".minusOne").on("click", function(){
  var decri = Number($(".product-option-quantity").val());
  if(decri >= 0) {
    decri -= 1;
  }
  $(".product-option-quantity").val(decri.toString());
});
$(".plusOne").on("click", function(){
  var incri = Number($(".product-option-quantity").val());
  incri += 1;
  $(".product-option-quantity").val(incri.toString());
});
$(".mOne").on("click", function(){
  var decri = Number($(".product-option-quantity").val());
  if(decri >= 0) {
    decri -= 1;
  }
  $(".product-option-quantity").val(decri.toString());
});
$(".pOne").on("click", function(){
  var incri = Number($(".product-option-quantity").val());
  incri += 1;
  $(".product-option-quantity").val(incri.toString());
});
// Cart-count-number
function myTimer() {
  var cnt = Number($(".cart-count-number").text());
  if(cnt>0) {
    $(".cart-count-number").css("display","block");
  }
}
var myVar = setInterval(myTimer,10);
function addItem(id) {
  $.ajax({
    type: 'POST',
    url: '/cart/add',
    dataType: 'json',
    data: $('#'+id).serialize(),
    success:function(response){
      location.reload();
    },
    error: Shopify.onError
  });
}
function noItem(){
  alert("Sorry!! Product Out Of Stock!");
}
function helLoooo() {
  if($(".add-to-cart").hasClass("disabled")){
    $(".aL").addClass("noProp");
    $(".add-to-cart").removeClass("disabled");
    $(".add-to-cart").val("Add to cart");
  }
}
function mnm(){
  if($(".add-to-cart").hasClass("disabled")){
  }
  else{
    $(".aL").removeClass(".noProp");
  }
}
mnm();
var mm = setInterval(helLoooo,10);

function HellO() {
  $(".noProp").on("click",function(e){
    e.preventDefault(); 
    alert("Please select size to proceed further!");		
  });
}
var mn = setTimeout(HellO,10);
function DCF(){
  if($("span.selected-text").text() == "CHOOSE SIZE"){
    $(".aL").addClass("noProp");
  }
  else{
    $(".aL").removeClass("noProp");
  }
}
var sds = setInterval(DCF,10);
$(".fa-search").on("click",function(){
  $(".icon-search").css("display","none");
  $(".fa-user").css("display","none");
  $(".mini-cart-wrapper").css("display","none");
  $("form.search").css("display","inline-flex");
});
$(".main-content").on("click",function(){
  $("form.search").css("display","none");
  $(".icon-search").css("display","block");
  $(".fa-user").css("display","block");
  $(".mini-cart-wrapper").css("display","block");
});
function Afgh(){
  $(".owl-next").html("<img src=\"https://cdn.shopify.com/s/files/1/0377/8858/2023/files/arrow-right-solid.svg?v=1591852817\">");
  $(".owl-prev").html("<img src=\"https://cdn.shopify.com/s/files/1/0377/8858/2023/files/arrow-left-solid.svg?v=1591853273\">");
  $("#shopify-section-1588762351974 article:first-child .exploreButton a").text("EXPLORE WOMENSWEAR");
  $("#shopify-section-1588762351974 article:first-child .exploreButton a").attr("href","\\collections\\womenswear");
  $("#shopify-section-1588762351974 article:last-child .exploreButton a").text("EXPLORE MENSWEAR");
  $("#shopify-section-1588762351974 article:last-child .exploreButton a").attr("href","\\collections\\menswear");
  $("section.sliderThree .owl-next").html("<img src=\"https://cdn.shopify.com/s/files/1/0377/8858/2023/files/Screenshot_85.png?v=1592303096\">");
  $("section.sliderThree .owl-prev").html("<img src=\"https://cdn.shopify.com/s/files/1/0377/8858/2023/files/Screenshot_86.png?v=1592303096\">");
  $("label.sort-by-toggle").text("Show Products:");
  //$(".reButton a").html("<img src=\"https://cdn.shopify.com/s/files/1/0299/6047/0664/files/Screenshot_94.png?v=1592653067\">");
}
var smfg = setTimeout(Afgh,1000);
$("img.spf-product-card__image.spf-product-card__image-main.gflazyautosizes.ls-is-cached.gflazyloaded").on("mouseover", function(){
  $(".spf-product__swatchs.round").css("display", "block");
});
$("img.spf-product-card__image.spf-product-card__image-main.gflazyautosizes.ls-is-cached.gflazyloaded").on("mouseout", function(){
  $(".spf-product__swatchs.round").css("display", "none");
});
//======================Custom js==================//
$('body.template-collection .collection-header .collection-featured-image img').parents().find('.collection').addClass('sechide');


// 5-12-2020
$( "body.template-product .share-icons" ).insertBefore( ".htmlsection" );
if ($('.size-guide').is(':empty')) { 
  $('.size-guide').remove();
} 
$("body.template-product .size-guide").insertAfter( "body.template-product .select-wrapper" );
// tab
function openCity(evt, cityName) {
  // Declare all variables
  var i, tabcontent, tablinks;
  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}


